// Copied verbatim from original/src/components/NumericInput.tsx (ADR-08 §2.1); helper import path changed.
import React from 'react';
import { toEnglishDigits, parseCommas, formatWithCommas } from '../lib/format.js';

interface NumericInputProps {
  value?: string | number | null;
  onChange: (val: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  dir?: 'ltr' | 'rtl';
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
}

export function NumericInput({ 
  value, 
  onChange, 
  placeholder, 
  className, 
  required, 
  disabled,
  dir = 'ltr',
  onFocus,
  onClick
}: NumericInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = toEnglishDigits(parseCommas(e.target.value));
    // Allow empty, numbers, and one decimal point
    if (rawValue === "" || /^\d*\.?\d*$/.test(rawValue)) {
      onChange(rawValue);
    }
  };

  const safeDisplayValue = value !== undefined && value !== null ? (formatWithCommas(value) || '') : '';

  return (
    <div className="relative group">
      <input
        type="text"
        dir={dir}
        lang="en"
        inputMode="decimal"
        value={safeDisplayValue}
        onChange={handleChange}
        placeholder={placeholder}
        style={{
          direction: dir,
          fontVariantNumeric: 'tabular-nums lining-nums',
          fontFeatureSettings: '"numr" 0, "tnum" 1, "lnum" 1',
        }}
        className={`w-full bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-xl px-3 md:px-3 py-2.5 focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 outline-none transition-all duration-300 font-bold font-mono text-xs sm:text-sm dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-600 ${className || ''}`}
        required={required}
        disabled={disabled}
        autoComplete="off"
        spellCheck={false}
        onFocus={onFocus}
        onClick={onClick}
      />
      <div className="absolute inset-0 rounded-2xl border border-primary-500/0 group-focus-within:border-primary-500/50 pointer-events-none transition-all duration-300" />
    </div>
  );
}
